<template>
  <div class="stat-table-container">
    <keep-alive>
      <v-data-table
        v-if="showDeleted"
        :headers="deleted_objects"
        :items="deleted_data"
        :loading="loading"
        hide-actions
        no-data-text="Данные отсутствуют"
        rows-per-page-text="Элементов на страницу"
        :rows-per-page-items="rowsPerPage"
        class="statistic-data-table"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <pre slot="activator">{{getShortValue(props.header.text)}}</pre>
            <pre>{{props.header.text }}</pre>
          </v-tooltip>
        </template>
        
        <template slot="items" slot-scope="props">
          <tr :class="{'just-added':props.item.selected}">
            <td class="text-xs-center"> {{ props.item.dateFormatted }} </td>
            <td class="text-xs-center" v-for="(el, index) in props.item.data">
              <v-edit-dialog
                :return-value.sync="el.value"
                large
                cancel-text="Отмена"
                save-text="Сохранить"
                @save="saveValue(el)"
                lazy v-if="canEdit">
                <span class="text-xs-center">{{ el.value }}</span>
                <v-text-field
                  type="number"
                  slot="input"
                  v-model="el.value"
                  label="Значение"
                  persistent-hint
                  hint="Нажмите Enter для сохранения"
                ></v-text-field>
              </v-edit-dialog>
              <span v-else>{{ el.value }}</span>
            </td>
          </tr>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          С {{ pageStart }} по {{ pageStop }}
        </template>
      </v-data-table>
      
      <v-data-table
        v-else
        :headers="objects"
        :items="data"
        :loading="loading"
        hide-actions
        no-data-text="Данные отсутствуют"
        rows-per-page-text="Элементов на страницу"
        :rows-per-page-items="rowsPerPage"
        class="statistic-data-table"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <pre slot="activator">{{getShortValue(props.header.text)}}</pre>
            <pre>{{props.header.text }}</pre>
          </v-tooltip>
        </template>
        
        <template slot="items" slot-scope="props">
          <tr :class="{'just-added':props.item.selected}">
            <td class="text-xs-center"> {{ props.item.dateFormatted }} </td>
            <td class="text-xs-center" v-for="(el, index) in props.item.data">
              <v-edit-dialog
                :return-value.sync="el.value"
                large
                cancel-text="Отмена"
                save-text="Сохранить"
                @open="currentValue=el.value"
                @save="saveValue(el)"
                lazy v-if="canEdit">
                <span class="text-xs-center">{{ el.value }}</span>
                <v-text-field
                  type="number"
                  slot="input"
                  v-model="el.value"
                  label="Значение"
                  persistent-hint
                  hint="Нажмите Enter для сохранения"
                ></v-text-field>
              </v-edit-dialog>
              <span v-else>{{ el.value }}</span>
            </td>
          </tr>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          С {{ pageStart }} по {{ pageStop }}
        </template>
      </v-data-table>
    </keep-alive>
    
  </div>
  
</template>

<script>
  export default {
    name : 'IndicatorTable',
    
    props:{
      objects:{
        type: Array,
        required: true
      },
      data:{
        type: Array,
        required: true
      },
      deleted_objects:{
        type: Array,
        required: true
      },
      deleted_data:{
        type: Array,
        required: true
      },
      loading:{
        type: Boolean,
        required: false,
        default: false
      },
      canEdit:{
        type: Boolean,
        required: false,
        default: true
      },
      showDeleted:{
        type: Boolean,
        required: false,
        default: false
      },
    },
    
    data() {
      return {
        rowsPerPage: [20, 50, 100, { text: 'Все', value: -1 }],
        currentValue: null,
      }
    },
    
    methods : {
      saveValue(item){
        item.prevValue = this.currentValue
        this.$emit('save', item)
      },
      
      getShortValue(text){
        let strings = text.split("\n")
        if(strings.length>3){
          let result = [strings[0], strings[1], "...", strings[strings.length-1]]
          return result.join("\n")
        } else {
          return text
        }
      }
    }
  }
</script>

<style>
  tr.just-added{
    background: #cbe8f6;
  }
  td.text-xs-center div.v-menu__activator {
    justify-content: center;
  }
  .statistic-data-table pre{
    font-family: inherit;
  }
  /*
  .data-table-header{
    font-weight: bold !important;
    color: #000 !important;
  }
  .statistic-data-table table td, .statistic-data-table table thead tr:first-child th{
    height: 30px !important;
    padding: 0 8px !important;
  }
  
  .statistic-data-table table thead tr {
    height: 30px;
  }
  
  .stat-table-container {
    overflow-x:scroll;
    margin-left:130px;
    overflow-y:visible;
    padding-bottom:1px;
  }
  .statistic-data-table table thead tr th{
    white-space: normal;
  }
  .statistic-data-table table tbody tr td, .statistic-data-table table thead tr th{
    min-width: 160px !important;
    max-width: 160px !important;
    z-index: 0;
  }
  .statistic-data-table table tbody tr td:first-child, .statistic-data-table table thead tr th:first-child{
    position:absolute;
    width:130px;
    left:0;
    top:auto;
    z-index: 2;
    background: white;
  }
  */
</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/IndicatorTable.vue